import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../lib/posthog';

/**
 * Fires a PostHog $pageview event on every route change.
 * Mount this once inside RouterProvider.
 */
export function PageviewTracker() {
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: location.pathname is the trigger; analytics is a stable module export
  useEffect(() => {
    analytics.capturePageview();
  }, [location.pathname]);

  return null;
}
